import React from 'react'
import { Navbar, Image } from 'react-bootstrap';
import { PANDA_FACE, INSTAGRAM, PANDA_LOGO } from '../../images/images';
import './Footer.scss';

export default function Footer(props) {
    return (
        <Navbar sticky={props.sticky} fixed={props.fixed} className="bg-dark">
            <Navbar.Brand>
                <img src={(props.page === 'home' || props.page === 'warning') ? PANDA_FACE : PANDA_LOGO} alt="..." height={32} href="/"/>
                {
                    (props.page === 'home' || props.page === 'warning') ?
                    <Navbar.Text className="legal-info">
                        <b>CONSUMO RESPONSABLE. LIVE PANDA</b>
                        <br/>
                        Corporación Panda Mix 1990 C.A. RIF: J-407567802 
                    </Navbar.Text> :
                    null
                }
            </Navbar.Brand>
            {
                (props.page === 'home' || props.page === 'warning') ?
                <Navbar.Brand className="instagram" href="https://www.instagram.com/pandamixve">
                    <Image src={INSTAGRAM} height={24}/>
                    pandamixve
                </Navbar.Brand> :
                null
            }
        </Navbar>
    )
}
